import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { environment } from 'src/environments/environment';

const FUSION_PATH = '/patient/fusion';
const API_FUSION_URL = environment.basePath + FUSION_PATH;

export interface FusionPatientReturn {
  zipFileTitle: string;
  zipFileContent: string;
}

export interface FusionPatientsRequest {
  idPatientSource: string;
  idPatientTarget: string;
  passphrase: string;
  valueToKeep: FusionConfig;
}

export interface FusionConfig {
  prenom: FusionConfigEnum;
  nom: FusionConfigEnum;
  dateNaissance: FusionConfigEnum;
  sexe: FusionConfigEnum;
}

export enum FusionConfigEnum {
  SOURCE = 'SOURCE',
  TARGET = 'TARGET',
}

export interface FusionPatientsFileConvertion {
  fusionResp: FusionPatientReturn;
  patientSource: InfosPatient;
  patientTarget: InfosPatient;
}

export interface UnfusionPatientsRequest {
  passphrase: string;
  zipFileContent: string;
  idPatientSource: string;
}

@Injectable({
  providedIn: 'root'
})
export class FusionPatientsService {

  constructor(
    private http: HttpClient,
  ) { }

  public async startFusionDossiersPatient(fusionParams: FusionPatientsRequest): Promise<FusionPatientReturn> {
    try {
      return await this.http.post<FusionPatientReturn>(`${API_FUSION_URL}`, fusionParams).toPromise();
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async startUnfusionDossiersPatient(unfusionParams: UnfusionPatientsRequest): Promise<string> {
    try {
      return await this.http.post<string>(`${API_FUSION_URL}/unfusion`, unfusionParams).toPromise();
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async fusionResponseToFile(fusionZip: FusionPatientReturn): Promise<void> {
    try {

      const _generateAndDlFile = (fileName: string, content: ArrayBuffer) => {
        try {
          const blob = new Blob([content], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
      
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
      
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (e) {
          console.error(e);
          throw e;
        }
      };

      const _base64ToArrBuffer = (base64: string): ArrayBuffer => {
        try {
          const binaryString = atob(base64);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          return bytes.buffer;
        } catch (e) {
          console.error(e);
          throw e;
        }
      }

      _generateAndDlFile(fusionZip.zipFileTitle, _base64ToArrBuffer(fusionZip.zipFileContent));
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
